var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.351301 3.39548C-0.527199 2.18712 0.349594 0.5 1.87972 0.5H10.1201C11.6735 0.5 12.544 2.23261 11.6186 3.43539L8.68106 7.25353C8.39194 7.62933 8.23524 8.0876 8.23524 8.559V11.2195C8.23524 12.4756 7.19485 13.5 5.90365 13.5C4.61245 13.5 3.57203 12.4756 3.57203 11.2195V8.5192C3.57203 8.0678 3.42835 7.62793 3.16151 7.26087L0.351301 3.39548ZM1.87972 1.5C1.19743 1.5 0.785882 2.26115 1.19082 2.81814L4.00103 6.68353C4.39095 7.21987 4.60022 7.86153 4.60022 8.5192V11.2195C4.60022 11.9301 5.18727 12.5 5.90365 12.5C6.62002 12.5 7.20705 11.9301 7.20705 11.2195V8.559C7.20705 7.8722 7.43531 7.20367 7.85783 6.65447L10.7954 2.83628C11.2219 2.28189 10.8127 1.5 10.1201 1.5H1.87972Z",
    fill: "#34415A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.354406 3.3544C-0.541223 2.14893 0.368224 0.5 1.87972 0.5H10.1201C11.6545 0.5 12.5588 2.19385 11.6154 3.39367L8.67784 7.1298C8.39022 7.49567 8.23531 7.94033 8.23531 8.3966C8.23531 8.6728 8.00513 8.8966 7.72122 8.8966C7.4373 8.8966 7.20712 8.6728 7.20712 8.3966C7.20712 7.71953 7.43709 7.06167 7.86112 6.5224L10.7987 2.78623C11.2072 2.26663 10.8318 1.5 10.1201 1.5H1.87972C1.17881 1.5 0.799982 2.24675 1.18779 2.76871L3.99799 6.55107C4.38936 7.07787 4.60025 7.70933 4.60025 8.35767V11C4.60025 11.2761 4.37008 11.5 4.08616 11.5C3.80223 11.5 3.57206 11.2761 3.57206 11V8.35767C3.57206 7.92073 3.43001 7.494 3.16461 7.1368L0.354406 3.3544Z",
    fill: "#34415A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.ffec01c7eb25db364fc5ca8691718f46.svg";
export { ForwardRef as ReactComponent };